export enum LocalDocumentType {
  BR = 'business_registration_doc',
  PATENT = 'patent_doc',
  LEGAL_INSTRUMENT = 'legal_instrument_doc',
  IDCARD = 'idcard_doc',
  FAMILY_BOOK = 'family_book_doc',
  PHOTO = 'photo_doc',
  SUPPORT = 'supporting_doc',
  HC_SUPPORT = 'hc_supporting_doc'
}
